import { render, staticRenderFns } from "./ClientsList.vue?vue&type=template&id=ec7f147a&scoped=true&"
import script from "./ClientsList.vue?vue&type=script&lang=js&"
export * from "./ClientsList.vue?vue&type=script&lang=js&"
import style0 from "./ClientsList.vue?vue&type=style&index=0&id=ec7f147a&lang=scss&scoped=true&"
import style1 from "./ClientsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7f147a",
  null
  
)

export default component.exports